<template>
  <tr
    class="product-offer-table-row"
    :class="publicationStatusClass"
  >
    <td>
      <span :title="publicationStatusDescription">{{publicationStatusIcon}}</span>
    </td>
    <td>
      <router-link :to="{ name: 'offer', params: { id: offer.id } }">
        <span v-if="offer.contract">
          {{$t('labels.withContract', { name: offer.contract.name })}}
        </span>
        <span v-else>{{$t('labels.noContract')}}</span>
      </router-link>
    </td>
    <td>
      <template v-if="onetimeDefaultPrice">
        <price :value="onetimeDefaultPrice" />
        <span v-if="onetimeWasPrice">
          (statt <price was :value="onetimeWasPrice" />)
        </span>
      </template>
      <text-placeholder v-else />
    </td>
    <td>
      <template v-if="monthlyDefaultPrice">
        <price :value="monthlyDefaultPrice" />
        <span v-if="monthlyWasPrice">
          (statt <price was :value="monthlyWasPrice" />)
        </span>
      </template>
      <text-placeholder v-else />
    </td>
    <td>
      <separated-list :items="tenantNames" />
    </td>
    <td>
      <data-grid-actions
        :edit-route="{ name: 'edit-offer', params: { id: offer.id }}"
        :removable="false"
      />
    </td>
  </tr>
</template>

<script>
import DataGridActions from '@/components/DataGridActions';
import Price from '@/components/Price';
import SeparatedList from '@/components/SeparatedList';
import TextPlaceholder from '@/components/TextPlaceholder';

const STATUS_PROBLEMS = {
  'price-missing': 'Publication has no prices, ' +
    'offer will not be visible in tenant',
};

export default {
  name: 'product-offer-table-row',
  components: {
    DataGridActions,
    Price,
    SeparatedList,
    TextPlaceholder,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    prices() {
      return this.offer.prices || [];
    },
    onetimeDefaultPrice() {
      return this.findPrice('DEFAULT', 'ONETIME');
    },
    onetimeWasPrice() {
      return this.findPrice('WAS', 'ONETIME');
    },
    monthlyDefaultPrice() {
      return this.findPrice('DEFAULT', 'MONTHLY');
    },
    monthlyWasPrice() {
      return this.findPrice('WAS', 'MONTHLY');
    },
    tenantNames() {
      return this.offer.tenants.map(tenant => tenant.name);
    },
    publicationStatusProblem() {
      const priceMissing = !(this.prices && this.prices.length > 0);
      if (priceMissing) return 'price-missing';
      return null;
    },
    publicationStatusOk() {
      return !this.publicationStatusProblem;
    },
    publicationStatusClass() {
      if (this.publicationStatusOk) return null;
      return 'product-offer-table-row--invalid';
    },
    publicationStatusDescription() {
      return STATUS_PROBLEMS[this.publicationStatusProblem];
    },
    publicationStatusIcon() {
      if (this.publicationStatusOk) return '☑️';
      return '🚨';
    },
  },
  methods: {
    findPrice(type, paymentFrequency) {
      const price = this.prices.find(p => p.type === type &&
        p.paymentFrequency === paymentFrequency && !p.organization);
      if (!price) return undefined;
      return price.value;
    },
  },
  i18n: {
    messages: {
      de: {
        labels: {
          noContract: 'ohne Vertrag',
          withContract: 'mit {name}',
        },
      },
    },
  },
};
</script>

<style lang="scss">
  .product-offer-table-row--invalid {
    background-color: #fcc;
  }
</style>



// WEBPACK FOOTER //
// ProductOfferTableRow.vue?dce68f06